module.exports = __webpack_public_path__ + "media/contract/Contract-1-1e87037f.png";